export default __webpack_public_path__ + "static/media/aquina_favicon.0bc45714.ico";